// Third party libs/components
import React, { useState, useEffect } from 'react';
import P from 'prop-types';
import * as Styled from './CreditCard.styles';

// Utils
import { translate as t } from '@utils/translate';
import { hideCVV, createHiddenCardNumber } from '@utils/creditCard';

const CreditCard = ({ data, animation, className, deleteAction, onDelete }) => {
  const [cardTheme, setCardTheme] = useState(true);
  const [cardData, setCardData] = useState({});
  const [hasData, setHasData] = useState(false);
  const [cardUI, setCardUI] = useState({});

  const TEXTS = {
    NEW_CARD: t('newCard'),
    NUMBER: t('cardNumber'),
    CVV: t('cvv'),
    NAME: t('cardHolderName'),
    EXPIRATION_DATE: t('validity'),
    CPF_CNPJ: t('docs'),
  };

  useEffect(() => {
    if (data) {
      setCardUI(oldState => ({
        ...oldState,
        number: data.card ? createHiddenCardNumber(data.card) : data.number,
        backgroundColor: data.card
          ? data.card?.cardBrand?.backgroundColor
          : data.backgroundColor,
        imageUrl: data.card ? data.card?.cardBrand?.imageUrl : data.imageUrl,
        hideInfo: data.hideInfo,
        holderName: data.holderName || '•••••••• •• ••••',
        expiryDate: data.expiryDate || '••/••',
        cvv: data.cvv || 'xxx',
      }));
    }
  }, [data]);

  useEffect(() => {
    if (data) {
      setCardData(data);

      if (data.card) {
        setCardData(oldState => ({
          ...oldState,
          ...data.card,
          ...data.card.cardBrand,
          number: createHiddenCardNumber(data.card),
          hideInfo: true,
        }));
      }
    }
  }, [data]);

  useEffect(() => {
    setHasData(
      !!cardData.number || !!cardData.holderName || !!cardData.numberDlocal
    );
  }, [cardData]);

  useEffect(() => {
    setCardTheme(!hasData ? 'default' : 'fulfilled');
  }, [hasData]);

  return (
    <Styled.Wrapper
      animation={animation}
      bgColor={cardUI.backgroundColor}
      theme={cardTheme}
      className={className}
    >
      <Styled.CardChip />
      <Styled.NewCardPlaceholder hasData={hasData}>
        {TEXTS.NEW_CARD}
      </Styled.NewCardPlaceholder>
      {cardUI.imageUrl ? (
        <Styled.CardFlag>
          <img src={cardUI.imageUrl} />
        </Styled.CardFlag>
      ) : null}
      {hasData ? (
        <Styled.CardData>
          <Styled.CardNumber>{cardUI.number}</Styled.CardNumber>
          {!cardUI.hideInfo && (
            <Styled.FooterItems>
              <div>
                <span>{TEXTS.NAME}</span>
                <span>{cardUI.holderName}</span>
              </div>
              <div>
                <span>{TEXTS.EXPIRATION_DATE}</span>
                <span>{cardUI.expiryDate}</span>
              </div>
              <div>
                <span>{TEXTS.CVV}</span>
                <Styled.CVVDots>{hideCVV(cardUI.cvv)}</Styled.CVVDots>
              </div>
            </Styled.FooterItems>
          )}
        </Styled.CardData>
      ) : null}
      {deleteAction && (
        <Styled.IconDelete
          onClick={e => {
            e.stopPropagation();
            onDelete();
          }}
        />
      )}
    </Styled.Wrapper>
  );
};

CreditCard.propTypes = {
  data: P.shape(),
  animation: P.bool,
  className: P.string,
  deleteAction: P.bool,
  onDelete: P.func,
};

CreditCard.defaultProps = {
  data: {},
  animation: false,
  flag: null,
};

export default CreditCard;
